import HomeJob from "../components/HomeJob/HomeJob";

const HomeJobPage = () => {
  return <HomeJob />;
};

export default HomeJobPage;
